import { BASE_PATH, BASE_PATH_EXTENSION } from "../../utils/constants";
import {getToken} from "../Auth/token";
import axios from "axios";

export async function listApi(controller) {
    const url = `${BASE_PATH}${BASE_PATH_EXTENSION}/admin/${controller}/`;
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.get(url, config)
}
